var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 26L27.625 16.25H11.375L19.5 26Z",
    fill: "#170F58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.25C10.5398 3.25 3.25 10.5398 3.25 19.5C3.25 28.4603 10.5398 35.75 19.5 35.75C28.4603 35.75 35.75 28.4603 35.75 19.5C35.75 10.5398 28.4603 3.25 19.5 3.25ZM19.5 32.5C12.3321 32.5 6.5 26.6679 6.5 19.5C6.5 12.3321 12.3321 6.5 19.5 6.5C26.6679 6.5 32.5 12.3321 32.5 19.5C32.5 26.6679 26.6679 32.5 19.5 32.5Z",
    fill: "#170F58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveDropdown);
export default __webpack_public_path__ + "static/media/inactive-dropdown.dfc921c92cf05b242be259a040735b62.svg";
export { ForwardRef as ReactComponent };